import type { ChatMessage, ChatTranscriptItem } from "~/ai-chat/model/chat-message";

// A short title derived from the first user message, for a chat that hasn't been named yet.
export function chatWindowTitle(items: ChatTranscriptItem[]): string {
  const firstUserMessage = items.find((item): item is ChatMessage => item.kind === "message" && item.role === "user");
  const words = firstUserMessage?.content.trim().split(/\s+/).slice(0, 6).join(" ") ?? "";
  if (!words) return "New chat";
  return words.length > 40 ? `${words.slice(0, 40).trimEnd()}…` : words;
}
